import { useState } from "react";
import { useSpCategorySearch } from "@/hooks/use-sp-category-search";
import type { SpTargetCategoryCandidate } from "@/lib/campaign-creation-api";
import type { EntryMatchType, EntryType } from "./strategy-target-model";

/** Free-form entry values stay local until they are added to the staged target selection. */
export function useTargetEntryForm(
  shopId: string,
  initialEntryMatchType: EntryMatchType,
  initialEntryBid: string,
) {
  const [entryType, setEntryType] = useState<EntryType>("keyword");
  const [entryValues, setEntryValues] = useState("");
  const [entryMatchType, setEntryMatchType] = useState<EntryMatchType>(initialEntryMatchType);
  const [entryBid, setEntryBid] = useState(initialEntryBid);
  const [entryError, setEntryError] = useState<string | null>(null);
  const [entryMode, setEntryMode] = useState(false);
  const categorySearch = useSpCategorySearch(shopId, {
    enabled: entryMode && entryType === "category",
  });
  const [selectedCategory, setSelectedCategory] = useState<SpTargetCategoryCandidate | null>(null);
  return {
    entryType,
    setEntryType,
    entryValues,
    setEntryValues,
    entryMatchType,
    setEntryMatchType,
    entryBid,
    setEntryBid,
    entryError,
    setEntryError,
    entryMode,
    setEntryMode,
    categorySearch,
    selectedCategory,
    setSelectedCategory,
  };
}

export type TargetEntryFormState = ReturnType<typeof useTargetEntryForm>;
